import {
  Grid,
  Paper,
  Table,
  TableRow,
  TableHead,
  TableBody,
  TableCell,
  Container,
  TableContainer,
  CircularProgress,
} from "@mui/material";

import ActionColumn from "./ActionColumn";

const EmailBotPolicyTable = (props) => {
  const {
    loadingStates,
    handleSubscriptionStatus,
    isFreePlanActive,
    emailBotPolicies,
    handleDeleteEmailBotPolicy,
    handleUpdateModal,
    handleActivateEmailPolicy,
  } = props;

  return (
    <Container>
      <Grid position="relative" height="" sx={{ py: 4 }}>
        <Grid item>
          <Grid>
            <TableContainer
              sx={{
                maxHeight: 460,
                border: "none",
                boxShadow: "none",
                backgroundColor: "transparent !important",
              }}
              component={Paper}
            >
              <Table
                stickyHeader
                sx={{ minWidth: 650 }}
                aria-label="simple table"
              >
                <TableHead>
                  <TableRow>
                    <TableCell align="left" sx={{ color: "#919eab" }}>
                      Title
                    </TableCell>
                    <TableCell align="left" sx={{ color: "#919eab" }}>
                      Status
                    </TableCell>
                    <TableCell sx={{ color: "#919eab" }}>Type</TableCell>
                    <TableCell sx={{ color: "#919eab" }}>
                      Credit Feature Policy
                    </TableCell>
                    <TableCell align="center" sx={{ color: "#919eab" }}>
                      Action
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {!loadingStates.fetchAllEmailPolicies ? (
                    emailBotPolicies?.length ? (
                      emailBotPolicies?.map((emailBotPolicy) => {
                        return (
                          <TableRow
                            key={emailBotPolicy?.id}
                            sx={{
                              "&:last-child td, &:last-child th": { border: 0 },
                            }}
                          >
                            <TableCell component="th" scope="row">
                              {emailBotPolicy?.title}
                            </TableCell>

                            <TableCell>
                              {emailBotPolicy?.status === "I"
                                ? "Inactive"
                                : "Active"}
                            </TableCell>

                            <TableCell component="th" scope="row">
                              {emailBotPolicy?.type}
                            </TableCell>

                            <TableCell component="th" scope="row">
                              {emailBotPolicy?.featurePolicyName}
                            </TableCell>

                            <ActionColumn
                              handleSubscriptionStatus={
                                handleSubscriptionStatus
                              }
                              handleDelete={handleDeleteEmailBotPolicy}
                              isFreePlanActive={isFreePlanActive}
                              emailBotPolicy={emailBotPolicy}
                              handleEdit={handleUpdateModal}
                              handleActivate={handleActivateEmailPolicy}
                            />
                          </TableRow>
                        );
                      })
                    ) : (
                      <TableRow
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                      >
                        <TableCell
                          component="th"
                          scope="row"
                          colSpan={5}
                          align="center"
                        >
                          No Credit Feature Policies
                        </TableCell>
                      </TableRow>
                    )
                  ) : (
                    <TableRow
                      sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                    >
                      <TableCell
                        component="th"
                        scope="row"
                        colSpan={6}
                        align="center"
                      >
                        <CircularProgress />
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
        </Grid>
      </Grid>
    </Container>
  );
};

export default EmailBotPolicyTable;
